import React from 'react'
import { useIntl } from 'react-intl'
import {
  Button,
  Checkbox,
  Modal,
  ModalBody,
  ModalFoot,
  ModalHead
} from 'mailup-web-components'
import './ModalCheckup.scss'
import { useRecoilCallback, useRecoilState, useRecoilValue } from 'recoil'
import { modalCheckup } from '../recoil/state/modal'

import { useHistory, useParams } from 'react-router'
import { messageState } from '../recoil/state/message'
import BlockingCheck from 'Pages/OverviewMessage/ModalCheckup/components/BlockingCheck/BlockingCheck'
import { callbackAddToWhiteList } from '../recoil/callbacks/callbacks'
import PotentialCheck from 'Pages/OverviewMessage/ModalCheckup/components/PotentialCheck/PotentialCheck'
import ImprovementsCheck from 'Pages/OverviewMessage/ModalCheckup/components/ImprovementsCheck/ImprovementsCheck'
import LinkCheck from 'Pages/OverviewMessage/ModalCheckup/components/LinkCheck/LinkCheck'

const ModalCheckup = () => {
  const intl = useIntl()
  const { id } = useParams()
  const history = useHistory()
  const [{ show, silencedCheck, blockToDisplay }, setOpen] = useRecoilState(
    modalCheckup
  )
  const { checkup } = useRecoilValue(messageState)
  const callbackAddToWList = useRecoilCallback(callbackAddToWhiteList, [])

  const makeTitle = () => {
    let title

    if (checkup && checkup.blocking > 0) {
      title = intl.formatMessage({
        id: 'Load.EmailCheckUp.ModalCheckUpKoTitle'
      })
    } else if (checkup && checkup.potential > 0) {
      title = intl.formatMessage({
        id: 'Load.EmailCheckUp.ModalCheckUpWarningTitle'
      })
    } else {
      title = intl.formatMessage({
        id: 'Load.EmailCheckUp.ModalCheckUpTitle'
      })
    }

    return title
  }

  const handleIgnoreAndClose = () => {
    callbackAddToWList(id)
    setOpen(prev => ({
      ...prev,
      show: false,
      silencedCheck: false
    }))
  }

  const handleSaveAndClose = () => {
    // Go to checkup => eventuale salvataggio impostazione alerts silenziati + redirect to App.aspx#/emailCheckUpSummary/{IdNL}
    callbackAddToWList(id)
    setOpen(prev => ({
      ...prev,
      show: false,
      silencedCheck: false
    }))

    history.push(`/messages/email/${id}/checkup/summary`)
  }

  const handleCheckChange = e => {
    const checked = e.target.checked
    setOpen(prev => ({
      ...prev,
      silencedCheck: checked
    }))
  }

  const handleClickDontShow = e => {
    e.preventDefault()
    e.stopPropagation()

    history.push(`/messages/email/${id}/checkup/summary`)
  }

  return (
    <Modal
      show={show}
      showClose
      closeOnOverlayClick
      onClose={handleIgnoreAndClose}
      data-mu-test='overview-message__modal-checkup-field'
      className='c-modal-check-up'
    >
      <ModalHead title={makeTitle()} />
      <ModalBody scrollable>
        <div className='c-modal-check-up__body'>
          <div className='c-modal-check-up__body__container'>
            {checkup && checkup.blocking > 0 && <BlockingCheck />}
            {checkup &&
              checkup.blocking === 0 &&
              checkup.potential > 0 &&
              blockToDisplay &&
              blockToDisplay.some(
                e => e.section === 'POTENTIAL' && e.toDisplay === true
              ) && <PotentialCheck />}
            {checkup &&
              checkup.blocking === 0 &&
              checkup.improvements > 0 &&
              blockToDisplay &&
              blockToDisplay.some(
                e => e.section === 'INFO' && e.toDisplay === true
              ) && (
                <>
                  <ImprovementsCheck />
                  <LinkCheck />
                </>
              )}
            {checkup && checkup.blocking === 0 && (
              <>
                <div>
                  <Checkbox
                    className='c-modal-check-up__body__container__checkbox'
                    checked={silencedCheck}
                    onChange={handleCheckChange}
                    label={intl.formatMessage(
                      {
                        id: 'Load.EmailCheckUp.ModalCheckUpTitleDontShowIntl'
                      },
                      {
                        link: content => (
                          <a key={content} onClick={handleClickDontShow}>
                            {content}
                          </a>
                        )
                      }
                    )}
                  />
                </div>
              </>
            )}
          </div>
        </div>
      </ModalBody>

      <ModalFoot>
        <Button
          onClick={handleIgnoreAndClose}
          kind='secondary'
          data-mu-test='overview-message__modal-checkup-button-cancel'
        >
          {intl.formatMessage({ id: 'Load.MailupCommon.Ignore' })}
        </Button>
        <Button
          onClick={handleSaveAndClose}
          kind='primary'
          data-mu-test='overview-message__modal-checkup-button-save'
        >
          {intl.formatMessage({ id: 'Load.EmailCheckUp.GoToCheckUp' })}
        </Button>
      </ModalFoot>
    </Modal>
  )
}

export default ModalCheckup
